import {
  Card,
  GKClientDataGrid,
  Grid2,
  PlusIcon,
  Show,
  StarFillIcon,
  Typography,
} from "components";
import { useAppSelector } from "store/store";
import { moneyCommaSeparator } from "utils";

const ViewFeePlans = () => {
  const { selectedBasket: data } = useAppSelector(
    (state) => state?.equityBasket,
  );

  return (
    <Grid2 container spacing={2}>
      <Show.When isTrue={data?.feePlansList?.length !== 0}>
        <Grid2
          bgcolor={"#F8F8F8"}
          p={3}
          borderRadius={"6px"}
          size={12}
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 16,
          }}
        >
          {data?.feePlansList?.map((item: any, index) => {
            return (
              <Card
                sx={{ p: 1, minWidth: "250px", maxWidth: "250px" }}
                key={index}
              >
                <Grid2 container alignItems={"center"} spacing={1}>
                  <Grid2 size={12} container alignItems={"center"} spacing={1}>
                    <Typography
                      fontWeight={600}
                      fontSize={16}
                      whiteSpace=" nowrap"
                      overflow=" hidden"
                      textOverflow=" ellipsis"
                    >
                      {item.name || "-"}
                    </Typography>
                    {item?.isDefault && (
                      <StarFillIcon color="#E6B532" height={16} width={16} />
                    )}
                  </Grid2>
                  <Show.When
                    isTrue={item.managementFee?.fee || item.performanceFee?.fee}
                  >
                    <Grid2
                      size={5}
                      display={"flex"}
                      justifyContent={"center"}
                      flexDirection={"column"}
                    >
                      <Typography
                        textTransform={"capitalize"}
                        color={"var(--neutral-500)"}
                        fontSize={12}
                      >
                        {item.managementFee?.name || "Management Fee"}
                      </Typography>
                      <Typography fontWeight={600}>
                        {item.managementFee?.feeType === "Flat Fee"
                          ? moneyCommaSeparator(item.managementFee?.fee || 0)
                          : `${item.managementFee?.fee || 0}%` || "-"}
                      </Typography>
                    </Grid2>
                    <Grid2
                      size={2}
                      display={"flex"}
                      alignItems={"center"}
                      justifyContent={"center"}
                    >
                      <div
                        style={{
                          borderRadius: 4,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          padding: 4,
                        }}
                      >
                        <PlusIcon color={"var(--neutral-500)"} />
                      </div>
                    </Grid2>
                    <Grid2
                      size={5}
                      display={"flex"}
                      justifyContent={"center"}
                      flexDirection={"column"}
                    >
                      <Typography
                        textTransform={"capitalize"}
                        color={"var(--neutral-500)"}
                        fontSize={12}
                      >
                        {item.performanceFee?.name || "Performance Fee"}
                      </Typography>
                      <Typography fontWeight={600}>
                        {`${item.performanceFee?.fee || 0}%` || "-"}
                      </Typography>
                    </Grid2>
                  </Show.When>
                  <Show.When
                    isTrue={
                      !item.managementFee?.fee && !item.performanceFee?.fee
                    }
                  >
                    <Grid2 size={12}>
                      <Typography fontWeight={600} color={"var(--neutral-500)"}>
                        Subscription Fee
                      </Typography>
                    </Grid2>
                  </Show.When>
                </Grid2>
              </Card>
            );
          })}
        </Grid2>
      </Show.When>
      <Grid2 size={12}>
        <GKClientDataGrid
          columns={[
            {
              field: "name",
              flex: 1,
              disableColumnMenu: true,
            },
            {
              field: "startDate",
              headerName: "Start Date",
              flex: 1,
              disableColumnMenu: true,
            },
            {
              field: "endDate",
              headerName: "End Date",
              flex: 1,
              disableColumnMenu: true,
            },
          ]}
          rows={[]}
          name="equityBasketFeePlan"
        />
      </Grid2>
    </Grid2>
  );
};

export default ViewFeePlans;
